(() => {
  window.swinger.eventHub.register('focus', '.swinger-textarea__textarea', (e) => {
    const wrapper = window.swinger.eventHub.getTarget(e).closest('.swinger-textarea');

    wrapper.classList.add('swinger-textarea--was-touched');
    wrapper.classList.add('swinger-textarea--is-focused');
  });

  window.swinger.eventHub.register('input', '.swinger-textarea__textarea', (e) => {
    const textarea = window.swinger.eventHub.getTarget(e);

    if (textarea.checkValidity) {
      if (textarea.checkValidity()) {
        textarea.removeAttribute('aria-invalid');
        const previousDescribedBy = textarea.getAttribute('data-aria-describedby');
        if (previousDescribedBy) {
          textarea.setAttribute('aria-describedby', previousDescribedBy);
        } else {
          textarea.removeAttribute('aria-describedby');
        }
      } else {
        textarea.setAttribute('aria-invalid', 'true');
        const previousDescribedBy = textarea.getAttribute('aria-describedby') || '';
        if (previousDescribedBy && !textarea.getAttribute('data-aria-describedby')) {
          textarea.setAttribute('data-aria-describedby', previousDescribedBy);
        }
        textarea.setAttribute('aria-describedby', `${previousDescribedBy} ${window.swinger.a11y.createDescription(textarea.validationMessage)}`);
      }
    }
  });

  window.swinger.eventHub.register('blur', '.swinger-textarea__textarea', (e) => {
    const textarea = window.swinger.eventHub.getTarget(e);
    const wrapper = textarea.closest('.swinger-textarea');

    wrapper.classList.remove('swinger-textarea--is-focused');

    if (textarea.checkValidity) {
      if (textarea.checkValidity()) {
        wrapper.removeAttribute('data-validation-message');
      } else {
        wrapper.setAttribute('data-validation-message', textarea.validationMessage);
      }
    }
  });
})();
